import { CommentSection as AntdCommentSection } from "@empglabs/backoffice-ui-kit"

const CommentSection = props => {
  return <AntdCommentSection {...props} />
}

export default CommentSection
